import { useStaticQuery, graphql } from 'gatsby';

const usePages = () => {
  const data = useStaticQuery(graphql`
    query usePagesQuery {
      allSanityPage {
        nodes {
          name
          type
          slug {
            current
          }
          order
          addToFooter
          heroBgImg {
            alt
            asset {
              gatsbyImageData(placeholder: BLURRED, formats: WEBP)
            }
          }
        }
      }
    }
  `);

  const pages = data.allSanityPage.nodes;

  return pages;
};

export { usePages };
